// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"920a4efd","228":"96a5b671"}[chunkId] + ".chunk.css";
};